import LifeCostBreakdownModal from "./LifeCostBreakdownModal";

export default LifeCostBreakdownModal;
